import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import ConversionTableStructure from './ConversionTableStructure';


const ConversionTableSheet = ({
  curFrom, curTo, rateDate, rate, fee,
}) => (
  <div>
    <Grid container >
      <Grid item xs={12} >
        <h2 style={{
 fontSize: '1.2rem', textAlign: 'center', padding: '0', margin: '0', textTransform: 'none',
}}
        >Umrechnungstabelle {curFrom.value} / {curTo.value}
        </h2>
      </Grid>
    </Grid>

    <Grid container>
      <Grid item xs >
        <ConversionTableStructure
          fee={fee}
          rate={rate}
          curFrom={curFrom}
          curTo={curTo}
          rowdef={[1, 2, 3, 4, 5, 10]}
          border
        />
      </Grid>

      <Grid item xs>
        <ConversionTableStructure
          fee={fee}
          rate={rate}
          curFrom={curFrom}
          curTo={curTo}
          rowdef={[15, 20, 25, 30, 35, 40]}
          border
        />
      </Grid>

      <Grid item xs>
        <ConversionTableStructure
          fee={fee}
          rate={rate}
          curFrom={curFrom}
          curTo={curTo}
          rowdef={[45, 50, 100, 250, 500, 1000]}
        />
      </Grid>
    </Grid>

    <div style={{ fontSize: '0.8rem', textAlign: 'center', marginTop: '0.25rem' }}>
      <span style={{ fontWeight: '300' }}>Kurs:</span> {rate} | <span style={{ fontWeight: '300' }}>Gebühr:</span> {fee * 10}% | <span style={{ fontWeight: '300' }}>Datum:</span> {rateDate.getDate()}.{rateDate.getMonth() + 1}.{rateDate.getFullYear()}<br />
    </div>
  </div>
);

ConversionTableSheet.propTypes = {
  curFrom: PropTypes.instanceOf(Object).isRequired,
  curTo: PropTypes.instanceOf(Object).isRequired,
  fee: PropTypes.number.isRequired,
  rateDate: PropTypes.instanceOf(Date).isRequired,
  rate: PropTypes.number.isRequired,
};

export default ConversionTableSheet;



// WEBPACK FOOTER //
// ./src/components/calculator/conversion-table/ConversionTableSheet.js